export const Types = {
    SAVE_LIST_PRODUCT: 'SAVE_LIST_PRODUCT',
}
